import React from 'react';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '../../data/site';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="border-t border-line bg-mint py-20 text-ink lg:py-24" data-id="element-506" data-mp="20ktk5o7r2z1s">
      <div className="mx-auto grid max-w-4xl items-center gap-10 px-5 text-center md:grid-cols-[220px_1fr] md:text-left lg:px-8" data-id="element-507" data-mp="24mevv68jt7ae">
        <svg aria-hidden="true" viewBox="0 0 200 200" className="mx-auto h-48 w-48 md:h-56 md:w-56" data-id="element-508" data-mp="29g1c18dx7tay">
          <circle cx="100" cy="100" r="96" fill="#2B0A05" stroke="#E36C20" strokeWidth="4" data-id="element-509" data-mp="2ef4843bxap6s" />
          <circle cx="100" cy="100" r="82" fill="none" stroke="#E36C20" strokeWidth="1.5" strokeDasharray="3 5" data-id="element-510" data-mp="2je7cdlk2wrdp" />
          <text x="100" y="104" textAnchor="middle" fontFamily="'Barlow Condensed', sans-serif" fontWeight="800" fontSize="84" fill="#E36C20" data-id="element-511" data-mp="2o9cxii5nq20q">
            10
          </text>
          <text x="100" y="134" textAnchor="middle" fontFamily="'Barlow Condensed', sans-serif" fontWeight="700" fontSize="22" letterSpacing="3" fill="#FFFFFF" data-id="element-512" data-mp="tyzgw0a3qf02">
            DAYS
          </text>
          <text x="100" y="156" textAnchor="middle" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="11" letterSpacing="2" fill="#E36C20" data-id="element-513" data-mp="3smztlhjau65g">
            MONEY-BACK
          </text>
        </svg>
        <div data-id="element-514" data-mp="3ivwp05r5v91f">
          <h2 id="guarantee-title" className="font-display text-[40px] font-bold uppercase leading-[0.95] sm:text-[56px]" data-id="element-515" data-mp="3itajscrqt5md">
            10-Day Money-Back <span className="text-gold-dark" data-id="element-516" data-mp="ff6hfmfxknxm">Guarantee</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-body sm:text-lg" data-id="element-517" data-mp="ag399t4nm1lf">
            Review the pack and decide whether it fits your classes. If it isn't right for you, email{' '}
            <a href={SUPPORT_MAILTO} className="font-bold text-ink underline underline-offset-4 hover:text-gold-dark" data-id="element-518" data-mp="5ijxczvfi0wn">
              {SUPPORT_EMAIL}
            </a>{' '}
            within 10 days of purchase to request a refund.
          </p>
        </div>
      </div>
    </section>;
}